<template>
    <div class="payment-authorization-page">
        <payment-authorization
            v-if="view === 'payment-authorization'"
            :account-id="account.id"
            :consumer-portal-data="data"
            :transactions="payments"
            :template="template"
            cancel-text="Cancel"
            @accepted="accept"
            @canceled="decline"
        />
        <electronic-consent
            v-else-if="view === 'electronic-consent'"
            :template="electronicConsentTemplate"
            :declined-template="electronicConsentDeclinedTemplate"
            :consumer-portal-data="data"
            :account-id="account.id"
            source="agent-portal-link"
            @accepted="navigate"
            @declined="navigate"
        />

    </div>
</template>

<script>
import PaymentAuthorization from '../components/PaymentAuthorization.vue'
import GatherContactInformation from '../components/GatherContactInformation.vue'
import ElectronicConsent from '../components/ElectronicConsent.vue'

export default {
    components: { ElectronicConsent, GatherContactInformation, PaymentAuthorization },
    props: {
        account: {
            type: Object,
        },
        paymentAuthorizationAgreement: {
            type: Object,
        },
        template: {
            type: String,
        },
        payments: {
            type: Array,
        },
        data: {},
        electronicConsentTemplate: {},
        electronicConsentDeclinedTemplate: {}
    },

    data() {
        return {
            loading: false,
            view: 'payment-authorization',
        }
    },

    methods: {
        navigate() {
            window.location = `${this.data.consumerPortalBaseUrl}/`
        },

        accept() {
            this.$http
                .post(`${this.$root.$refs.app.consumerPortalBaseUrl}/api/payment-authorization-agreement/${this.paymentAuthorizationAgreement.id}/accept`)
                .then(() => {
                    if (this.electronicConsentTemplate !== 'false') {
                        this.view = 'electronic-consent';
                    } else {
                        this.navigate();
                    }
                });
        },

        decline() {
            this.$http
                .post(`${this.$root.$refs.app.consumerPortalBaseUrl}/api/payment-authorization-agreement/${this.paymentAuthorizationAgreement.id}/decline`)
                .then(() => {
                    if (this.electronicConsentTemplate !== 'false') {
                        this.view = 'electronic-consent';
                    } else {
                        this.navigate();
                    }
                });
        },
    },
}
</script>
